import Navbar from "@/components/Navbar";
import { Card, CardHeader, CardContent } from "@/components/ui/card";
import TeamMembersGrid from "@/components/ispai/TeamMembersGrid";
import DomainElements from "@/components/ispai/DomainElements";
import IspaiHeader from "@/components/ispai/IspaiHeader";
import { Domain } from "@/types/domain";
import KnowledgeNetworkStats from "@/components/shared/KnowledgeNetworkStats";
import { useTranslation } from "@/hooks/useTranslation";
const domains: Domain[] = [{
  symbol: "KB Creation",
  name: "KB Creation",
  categories: "Knowledge Curation, Metadata Standards, Content Development, Version Control, AI-ready Data"
}, {
  symbol: "KB Composition",
  name: "KB Composition",
  categories: "Multi-KB Integration, Solution Assembly, Dependencies, AI Alignment, Solution Packaging"
}, {
  symbol: "Tokenized Ecosystems",
  name: "Tokenized Ecosystems",
  categories: "OWL Tokens, NFTrees, Staking, Tokenomics, Marketplace Dynamics"
}, {
  symbol: "Governance",
  name: "Governance",
  categories: "DAO Structures, Voting, GibRating, Dispute Resolution, Guidelines"
}, {
  symbol: "Human in the Loop",
  name: "Human in the Loop",
  categories: "HITL Validation, AI Collaboration, GenAI Training, Role-based AI, Human-AI Synergy"
}, {
  symbol: "Human over the Loop",
  name: "Human over the Loop",
  categories: "Oversight Frameworks, Decision Authority, Human Supervision, AI Governance, Control Mechanisms"
}, {
  symbol: "Platform Tech",
  name: "Platform Tech",
  categories: "Blockchain Attribution, LLM Integration, API Ecosystem, Collaboration Tools, Security"
}, {
  symbol: "Use Cases",
  name: "Use Cases",
  categories: "Industry Applications, Solution Calls, Enterprise Integration, AI Solutions"
}, {
  symbol: "Revenue Models",
  name: "Revenue Models",
  categories: "Solution Bounties, Enterprise Tiers, KB Licensing, Marketplace Fees, Token Funding"
}, {
  symbol: "Ethics & Compliance",
  name: "Ethics & Compliance",
  categories: "IP Management, AI Ethics, Privacy, Regulatory Compliance, Content Authenticity"
}, {
  symbol: "Growth & Engagement",
  name: "Growth & Engagement",
  categories: "Community Building, Education, Incentives, Industry Partners, Marketing"
}, {
  symbol: "Investors",
  name: "Investors",
  categories: "Investment Strategies, Portfolio Management, Risk Assessment, ROI Analysis, Market Trends"
}, {
  symbol: "Employees",
  name: "Employees",
  categories: "HR Policies, Training Programs, Performance Metrics, Career Development, Benefits Management"
}, {
  symbol: "Partners",
  name: "Partners",
  categories: "Partnership Agreements, Collaboration Frameworks, Joint Ventures, Alliance Management, Network Growth"
}, {
  symbol: "Patents",
  name: "Patents",
  categories: "Patent Applications, IP Protection, Innovation Documentation, Patent Strategy, Portfolio Management"
}, {
  symbol: "Trademarks",
  name: "Trademarks",
  categories: "Brand Protection, Registration Process, Global Trademark Strategy, Enforcement Guidelines, Portfolio Management"
}, {
  symbol: "Copyright",
  name: "Copyright",
  categories: "Content Protection, Rights Management, Licensing Strategy, Digital Rights, Fair Use Guidelines"
}, {
  symbol: "Adoption",
  name: "Adoption",
  categories: "Implementation Strategies, User Onboarding, Change Management, Best Practices, Success Metrics"
}, {
  symbol: "Interoperability",
  name: "Interoperability",
  categories: "Technical Standards, Integration Protocols, Cross-platform Compatibility, API Management, Data Exchange"
}, {
  symbol: "Organizations",
  name: "Organizations",
  categories: "Organizational Structure, Governance Models, Process Management, Resource Allocation, Strategic Planning"
}, {
  symbol: "Enterprises",
  name: "Enterprises",
  categories: "Enterprise Architecture, Digital Transformation, Business Process Optimization, Risk Management, Innovation Strategy"
}, {
  symbol: "Individuals",
  name: "Individuals",
  categories: "Personal Development, Skill Enhancement, Career Growth, Knowledge Management, Professional Networking"
}, {
  symbol: "Roles",
  name: "Roles",
  categories: "Curator, Contributor, Confirmer, Composer, Consumer"
}, {
  symbol: "Regulatory",
  name: "Regulatory",
  categories: "Compliance Frameworks, Industry Standards, Legal Requirements, Policy Management, Audit Procedures"
}, {
  symbol: "Competition",
  name: "Competition",
  categories: "Market Analysis, Competitive Intelligence, Strategic Positioning, Differentiation Strategy, Industry Benchmarking"
}];
const teamMembers = [{
  image: "/lovable-uploads/39305cb5-47ab-4254-81cd-6765d6c7cad4.png",
  alt: "GTM Advisor"
}, {
  image: "/lovable-uploads/a9e5eb36-05b8-4ba5-b8f6-917e1d77c481.png",
  alt: "Innovation Logistics"
}, {
  image: "/lovable-uploads/8c9f443c-2fbc-4763-8a1a-69d3f4076e4d.png",
  alt: "Brand Marketing Expert"
}, {
  image: "/lovable-uploads/487775c8-5ff0-4b5f-bc47-b449eb15f984.png",
  alt: "Finance Expert"
}, {
  image: "/lovable-uploads/e98049ee-495a-4700-9f03-d39e22e3a116.png",
  alt: "Strategic Sourcing"
}, {
  image: "/lovable-uploads/084aa47a-c241-4e95-a90d-8bf41d5c5a0a.png",
  alt: "Security Expert"
}, {
  image: "/lovable-uploads/01817a77-50a5-4764-a5be-a08ff84c2c0d.png",
  alt: "Blockchain Expert"
}, {
  image: "/lovable-uploads/645369ee-7ed8-4496-a783-9195e483aded.png",
  alt: "Innovation Expert"
}, {
  image: "/lovable-uploads/fdd951b2-2403-445a-9505-77bbb0050939.png",
  alt: "AI For All"
}, {
  image: "/lovable-uploads/27886eb6-0acd-4b44-96bd-a9103cb86f05.png",
  alt: "Product Design Expert"
}, {
  image: "/lovable-uploads/90811df9-aabf-443e-803c-c0e051fa300b.png",
  alt: "Supply Chain and Law Expert"
}, {
  image: "/lovable-uploads/f05e9de4-03a9-4e39-8b8c-901d4e19cfd6.png",
  alt: "Owl #13"
}];
const networkStats = {
  totalParticipants: 1348750,
  activeContributors: "$7,600,225",
  knowledgeBases: 35647,
  totalSolutions: 547,
  departments: [{
    name: "KB Creation Team",
    participants: 312
  }, {
    name: "Solution Assembly",
    participants: 287
  }, {
    name: "Peer Confirmation",
    participants: 264
  }, {
    name: "Marketplace",
    participants: 198
  }, {
    name: "Network",
    participants: 287
  }]
};
const IspaiChannel = () => {
  const { t } = useTranslation();
  return <div className="min-h-screen bg-muted">
      <Navbar />
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <TeamMembersGrid members={teamMembers} />
        
        <Card className="mb-6">
          <CardHeader>
            <IspaiHeader />
          </CardHeader>
          <CardContent>
            <div className="mb-8">
              <h2 className="text-xl font-semibold mb-4">{t('ispai.platformDashboard')}</h2>
              <KnowledgeNetworkStats {...networkStats} channelName="ispai" solutionsLabel="Solution Bounties" />
            </div>

            <div onClick={() => window.open('https://img1.wsimg.com/blobby/go/70e764c8-c764-4e83-ada3-5ccb3a393f3d/downloads/957872b3-238f-4812-8995-e790421fa472/iSPAI%20Industry_iSPAI.pdf?ver=1737391654284', '_blank')} className="bg-white border-2 border-black p-4 rounded-lg cursor-pointer hover:bg-gray-50 transition-colors mb-6">
              <h3 className="text-xl font-semibold text-center">{t('ispai.industryTemplate')}</h3>
            </div>

            

            <h2 className="text-xl font-semibold mb-4">{t('ispai.domainElements')}</h2>
            <DomainElements domains={domains} />
          </CardContent>
        </Card>
      </main>
    </div>;
};
export default IspaiChannel;